<template>
    <div>
        <iframe v-bind:src="iframeURL" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <h3>{{title}}</h3>
    </div>
</template>

<script>
export default {
  props: ['url', 'title'],
  data: () => ({
    iframeURL: ''
  }),
  created: function () {
    this.getIframeURL()
  },
  methods: {
    getIframeURL () {
      if (this.url.includes('youtu.be')) {
        const data = this.url.split('/')
        const id = data[data.length - 1]
        this.iframeURL = 'https://www.youtube.com/embed/' + id
      } else {
        const data = this.url.split('/')
        const id = data[data.length - 1].split('=')[1].split('&')[0]
        this.iframeURL = 'https://www.youtube.com/embed/' + id
      }
    }
  }
}
</script>

<style scope>
iframe {
    width: 100%;
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/YouTube.vue